module.exports = __webpack_public_path__ + "static/media/invit.4a7ef4ea.svg";